import { gql } from '@apollo/client'
import { DISPLAY_FRAGMENT } from '../fragments/DisplayFragment'

export const GET_RANDOM_OBSERVED_DISPLAY = gql`
  query GetRandomObservedDisplay {
    randomObservedDisplay {
      ...Display
    }
  }
  ${DISPLAY_FRAGMENT}
`
